/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Button, Row, Col, FormGroup, Label, Input, FormFeedback } from 'reactstrap'

import { css } from '@emotion/react';
import { RingLoader } from 'react-spinners'

import ConfirmationModal from '../widgets/ConfirmationModal'

import {AppContext} from '../AppContext';

class BroadcastEmail extends React.Component
{  
  constructor(props)
  {
    super()

    this.state =
    {
      subject: '',
      subjectValid: undefined,
      emailBody: '',
      modalText: '',
      confirmationModalIsOpen: false,
      sendTestDisabled: true,
      sendEmailDisabled: true,
      spinnerIsSpinning: false
    }

    this.setSubject = this.setSubject.bind(this);
    this.setEmailText = this.setEmailText.bind(this);
    this.sendTestEmail = this.sendTestEmail.bind(this);
    this.sendEmail = this.sendEmail.bind(this);
    this.sendEmailConfirmed = this.sendEmailConfirmed.bind(this);
  }

  render()
  {
    if (this.props.tabId !== this.props.tabIndex) return false;

    let modalText = 'You are about to send an email to all users of this installation of the SecureObject Vault.  If the test-email that you sent to yourthis is acceptable, hit the OK button to proceed - or press the Cancel button to return to the previous screen.'

    const spinnerCss = css`
      display: block;
      margin: 0 auto;
      border-color: red;
    `;

    return(
      <div>
        <Row style={{paddingTop: "10px"}}>
          <Col><h3>Use this tab to send an email to all subscribers/users of the system.</h3></Col>
        </Row>
        <FormGroup row>
          <Label for="subject" sm="1">Subject</Label>
          <Col sm={3}>
            <Input type="text" id="subject" placeholder="Enter the subject of the email..."
              value={this.state.subject} onChange={this.setSubject}
              invalid={(undefined === this.state.emailAddressValid ? undefined : !this.state.emailAddressValid)} 
              valid={(undefined === this.state.emailAddressValid ? undefined : this.state.emailAddressValid)} 
              autoFocus
            />
            <FormFeedback valid={false}>{this.state.emailAddressFB}</FormFeedback>
          </Col>
        </FormGroup>
        <FormGroup row>
          <Label for="emailBody" sm="1">Email Text</Label>        
          <Col sm="4">
            <Input type="textarea" style={{height: "150px"}} id="emailBody" value={this.state.emailBody} onChange={this.setEmailText} 
              placeholder={'Enter the text of your email message here...'} />
          </Col>
        </FormGroup>
        <Row style={{paddingTop: "10px"}}>
          <Col sm={{ size: 2, offset: 1 }}>
            <Button onClick={this.sendTestEmail} disabled={this.state.sendTestDisabled} color="primary">Send Test</Button>
          </Col>
          <Col>
              <Button title='You have to send a test email in order to enable this button' onClick={this.sendEmail} 
                disabled={this.state.sendEmailDisabled} color="primary">Send Email</Button>
          </Col>
        </Row>
        <ConfirmationModal modalIsOpen={this.state.confirmationModalIsOpen} closeModal={this.sendEmailConfirmed}
          modalText={modalText}
        />
        <div style={{position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)"}}>
          <RingLoader css={spinnerCss} size={75} color={'#4A90E2'} loading={this.state.spinnerIsSpinning}/>          
        </div>
     </div>
    );
  }

  sendEmail(event)
  {
    this.setState({confirmationModalIsOpen: true});
  }

  async sendEmailConfirmed(confirmed)
  {
    this.setState({confirmationModalIsOpen: false});
    if (!confirmed) return;

    this.setState({sendTestDisabled: true, sendEmailDisabled: true, spinnerIsSpinning: true});

    var bodyData = {};
    bodyData.subject = this.state.subject;
    bodyData.emailBody = this.state.emailBody;

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'sendEmailToAllUsers', bodyData);
    if ('success' !== result.status)
    {
      this.setState({sendTestDisabled: false, spinnerIsSpinning: false});
      return this.context.dbTwig.apiErrorHandler(result, 'Error sending broadcast email');
    } 

    this.context.postNotification('info', 'Email sent to all users of the system.');
    this.setState({subject: '', emailBody: '', spinnerIsSpinning: false});
  }

  async sendTestEmail(event)
  {
    this.setState({sendTestDisabled: true, spinnerIsSpinning: true});
    event.preventDefault();

    var bodyData = {};
    bodyData.subject = this.state.subject;
    bodyData.emailBody = this.state.emailBody;

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'sendTestEmail', bodyData);
    if ('success' !== result.status)
    {
      this.setState({sendTestDisabled: false, spinnerIsSpinning: false});
      return this.context.dbTwig.apiErrorHandler(result, 'Error sending a test email');
    } 

    this.context.postNotification('info', 'Test email sent.');
    this.setState({sendTestDisabled: false, sendEmailDisabled: false, spinnerIsSpinning: false});
  }

  setEmailText(event)
  {
    this.setState(
    {
      emailBody: event.target.value, 
      sendEmailDisabled: true
    });
  }

  setSubject(event)
  {
    this.setState(
      {
        subject: event.target.value, 
        sendTestDisabled: '' === event.target.value ? true : false, 
        sendEmailDisabled: true
      });
  }
}

BroadcastEmail.contextType = AppContext;

export default BroadcastEmail